import React from 'react'
import { Link } from 'react-router-dom'

export const RegisterHeader = ({ logoImg, logoText }) => {
  return (
    <div className="text-center mb-6">
      <Link to="/" className="inline-block">
        <img
          src={logoImg}
          alt="Logo"
          className="mx-auto w-12 sm:w-16 h-auto"
        />
        <img
          src={logoText}
          alt="Logo Text"
          className="mx-auto w-32 sm:w-40 h-auto mt-3"
        />
      </Link>
      <p className="text-sm text-gray-600 mt-3">Join our real estate platform</p>
    </div>
  )
}